/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var CarStatus;
(function (CarStatus) {
    CarStatus["Available"] = "Available";
    CarStatus["Unavailable"] = "Unavailable";
    CarStatus["ForSell"] = "ForSell";
    CarStatus["Sold"] = "Sold";
    CarStatus["Deleted"] = "Deleted";
})(CarStatus || (CarStatus = {}));
export function CarStatusFromJSON(json) {
    return CarStatusFromJSONTyped(json, false);
}
export function CarStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function CarStatusToJSON(value) {
    return value;
}
